import { DONOTCALLDATA, CONTACTDATA, FETCH, FETCH2 } from './actionType'
import axios from 'axios'
import tapConfig from '../../tapConfig'

export function doNotCallData(data) {
  return {
    type: DONOTCALLDATA,
    data: data,
  }
}
export function contactData(data) {
  return {
    type: CONTACTDATA,
    data: data,
  }
}

export function doNotCallListData(blossomID) {
  return function (dispatch) {
    tapConfig()
      .then((config) => {
        const apiKey = config.target_outreach_manager.apiKey
        dispatch(apiFetching(true))
        axios
          .get(
            config.target_outreach_manager.url +
              'target_emergency_alerts/v1/do_not_call_entries?key=' +
              encodeURIComponent(apiKey) +
              '&group_id=' +
              encodeURIComponent(blossomID),
          )
          .then(function (response) {
            if (response.data === null) {
              response.data = ''
            }
            dispatch(doNotCallListResponseData(response))
            dispatch(apiFetching(false))
          })
          .catch(function () {
            // removed error from function
            dispatch(apiFetching(false))
          })
      })
      .catch((error) => {
        console.error('Error fetching tapConfig:', error)
        dispatch(apiFetching(false))
      })
  }
}

export function addDoNotCallEntry(blossomID, entry) {
  return function (dispatch) {
    tapConfig()
      .then((config) => {
        const apiKey = config.target_outreach_manager.apiKey
        dispatch(apiFetching2(true))
        axios
          .post(
            config.target_outreach_manager.url +
              'target_emergency_alerts/v1/do_not_call_entries?key=' +
              encodeURIComponent(apiKey),
            {
              group_id: blossomID,
              address: entry,
            },
          )
          .then(function (response) {
            // Added below to  get a pop up window when successful
            if (response.status === 201) {
              window.alert('DNC Entry Successfully Added')
            } else {
              window.alert('DNC Entry Not Successfully Added')
            }
            dispatch(doNotCallListData(blossomID))
            dispatch(apiFetching2(false))
          })
          .catch(function () {
            // removed error from function
            dispatch(apiFetching2(false))
          })
      })
      .catch((error) => {
        console.error('Error fetching tapConfig:', error)
        dispatch(apiFetching2(false))
      })
  }
}

export function removeDoNotCallEntry(blossomID, entry) {
  return function (dispatch) {
    tapConfig()
      .then((config) => {
        const apiKey = config.target_outreach_manager.apiKey
        dispatch(apiFetching2(true))
        axios
          .delete(
            config.target_outreach_manager.url +
              'target_emergency_alerts/v1/do_not_call_entries?key=' +
              encodeURIComponent(apiKey) +
              '&group_id=' +
              encodeURIComponent(blossomID) +
              '&address=' +
              encodeURIComponent(entry),
          )
          .then(function (response) {
            // Added below to  get a pop up window when successful
            if (response.status === 204) {
              window.alert('DNC Entry Successfully Deleted')
            } else {
              window.alert('DNC Entry Not Successfully Added')
            }
            dispatch(doNotCallListData(blossomID))
            dispatch(apiFetching2(false))
          })
          .catch(function () {
            // removed error from function
            dispatch(apiFetching2(false))
          })
      })
      .catch((error) => {
        console.error('Error fetching tapConfig:', error)
        dispatch(apiFetching2(false))
      })
  }
}

function doNotCallListResponseData(response) {
  return {
    type: DONOTCALLDATA,
    data: response.data,
  }
}

function apiFetching(status) {
  return {
    type: FETCH,
    fetching: status,
  }
}

function apiFetching2(status) {
  return {
    type: FETCH2,
    fetching: status,
  }
}
